import {Formik} from 'formik';

import {FormComponent} from './FormComponent';

import {RecordSchema} from './RecordSchema';

import {FormWithButtons} from '@flexinet/ui-components';

import {Organization} from '../types';
import {useNavigate} from "react-router-dom";
import {stage} from "../../../../config/stage";

export const RecordForm = ({
                               record,
                               handleSubmit,
                           }: {
    // Optional: the Add page has no record yet (FNP-948).

    record?: Omit<Organization, 'id'>,
    handleSubmit: (values: Organization) => void
}) => {
    const navigate = useNavigate()

    const onSubmit = (values: Organization) => {

        console.debug(values)

        handleSubmit(values);
        navigate('/organizations');
    };

    const onCancel = () => {
        navigate('/organizations');
    };


    let initialValues = {} as Organization;

    if (record) {
        initialValues = Object.assign({}, initialValues, record);
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={RecordSchema}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={onCancel} debug={false && stage === 'ide'} {...rest}  >
                    <FormComponent handleSubmit={handleSubmit} isSubmitting={isSubmitting} {...rest}/>
                </FormWithButtons>)}
        </Formik>
    );
};
